import angular from 'angular';

import SearchComponent from './search.cmpt';

export default angular
    .module('application.component.search', [])
    .component(SearchComponent.selector, SearchComponent);



// WEBPACK FOOTER //
// ./src/application/component/search/index.js